// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__EtNt2","center":"Home_center__V0nxp","logo":"Home_logo__80mSr"};